import { COLORS } from '@elo-kit/constants/general.constants'

import { getFontStyles } from '@elo-kit/utils/fonts.utils'
import { cleanupFonts } from 'utils/fonts.utils'

const { eloBlue, eloWhite } = COLORS

// TODO: update with using createUseStyles
const sideNavigationStyles = (theme) => ({
  menuContainer: {
    position: 'relative',
    background: `${theme.lesson.sidebarBackground || eloWhite} !important`,
  },
  menuContainerFixed: {
    position: 'fixed',
    top: 0,
    background: `${theme.lesson.sidebarBackground || eloWhite} !important`,
  },
  menuContainerBottomCutted: {
    bottom: `${theme.footerHeight + 30}px !important`,
  },
  progressContainer: {
    background: `${theme.lesson.sidebarBackground || eloWhite} !important`,
    '& .progress': {
      background: `${theme.lesson.progressBackground || '#efedef'} !important`,
    },
    '& .progress-bar': {
      background: `${theme.lesson.progressColor || eloBlue} !important`,
    },
    '& .progress-title div': {
      fontSize: `${theme.lesson.progressSize || 13}px !important`,
      fontFamily: `${cleanupFonts(theme.lesson.progressFont) || 'Montserrat Medium'} !important`,
      ...getFontStyles(theme.lesson.progressStyle),
      color: `${theme.lesson.progressFontColor || '#787878'} !important`,
    },
    '& .mobile-close': {
      '& .fa-times-circle': {
        display: 'none',
      },

      '@media (max-width: 991px)': {
        width: '100%',

        '& .fa-times-circle': {
          width: '100%',
          textAlign: 'right',
          fontSize: 20,
          color: theme.buttonColor || eloBlue,
          marginBottom: 22,
          display: 'block',
        },
      },
    },
  },
  sideNavContainer: {
    marginTop: '',
    '& .category-name': {
      fontSize: `${theme.lesson.sidebarSize || 13}px !important`,
      fontFamily: cleanupFonts(theme.lesson.sidebarFont) || 'Montserrat Reg',
      ...getFontStyles(theme.lesson.sidebarStyle, true),
      color: theme.lesson.sidebarFontColor || '#212529',
    },
    '& .lesson-wrap': {
      fontSize: `${theme.lesson.sidebarSize || 13}px !important`,
      fontFamily: `${cleanupFonts(theme.lesson.sidebarFont) || 'Montserrat Reg'} !important`,
      ...getFontStyles(theme.lesson.sidebarStyle),
      color: `${theme.lesson.sidebarFontColor || '#212529'} !important`,
      '&.active': {
        color: '#ffffff !important',
      },
      '& .fa-lock': {
        color: '#88888880 !important',
      },
    },
    '& .lesson-name': {
      fontSize: `${theme.lesson.sidebarSize || 13}px !important`,
      fontFamily: `${cleanupFonts(theme.lesson.sidebarFont) || 'Montserrat Reg'} !important`,
      ...getFontStyles(theme.lesson.sidebarStyle),
    },
    '& .category-lessons-overlay': {
      width: '100%',
      height: '100%',
      opacity: 0.05,
      position: 'absolute',
      background: '#000000',
    },
    '& .category-lessons': {
      position: 'relative',
      background: `${theme.lesson.sidebarBackground || eloWhite} !important`,
    },
    '& .lesson-wrap.active': {
      background: `${theme.lesson.sidebarActiveColor || eloBlue} !important`,
    },
    '& .quiz-item': {
      background: `${theme.lesson.sidebarActiveColor || eloBlue} !important`,
      color: '#ffffff !important',
      fontSize: `${theme.lesson.sidebarSize || 13}px !important`,
      fontFamily: `${cleanupFonts(theme.lesson.sidebarFont) || 'Montserrat Reg'} !important`,
      ...getFontStyles(theme.lesson.sidebarStyle),
    },
    '& .fa-caret-right': {
      color: `${theme.lesson.sidebarActiveColor || eloBlue} !important`,
    },
  },
  rightSideNav: {
    '&.course-side-nav': {
      marginTop: 0,
      marginLeft: 0,
    },

    '@media (max-width: 991px)': {
      '&.course-side-nav.course-side-nav--active': {
        width: '100%',
      },

      '&.course-side-nav .menu-wrapper': {
        width: '100%',
      },
    },
  },

  leftSideNav: {
    '@media (max-width: 991px)': {
      '&.course-side-nav.course-side-nav--active': {
        width: '100%',
      },

      '&.course-side-nav .menu-wrapper': {
        width: '100%',
      },
    },
  },

  rightFixedSideNav: {
    '@media (max-width: 991px)': {
      '&.course-side-nav .menu-wrapper': {
        width: 'calc(100% - 29px)',
      },
    },
  },
})

export default sideNavigationStyles
